export const environment = {
  production: true,
  callbackUri: 'https://freemasen.github.io/healthTracker/setup-sync/',
  dropboxTimeout: 5 * 60 * 1000,
};
